import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { axiosPrivate } from 'app/utils';

async function getTodayVideoCallAppointments({ pharmacyId, startDate, endDate }) {
  const queryParams = new URLSearchParams({
    statusIn: 'booked',
    pharmacyId,
    startDate,
    endDate,
    isVideoCall: 'true',
    sortBy: 'appointmentTime',
    sortOrder: 'asc',
  });
  const response = await axiosPrivate.get(`/v3/pharmacist/appointments?${queryParams.toString()}`);

  return response.data;
}

const toVideoCall = (appointment, currentTime) => {
  const startsInSeconds = dayjs(appointment.startDate).diff(currentTime, 'second');
  const isUpcoming = startsInSeconds > 0 && startsInSeconds <= 3600;
  const isInProgress = startsInSeconds <= 0 && dayjs(appointment.endDate).isAfter(currentTime);

  return { ...appointment, startsInSeconds, isUpcoming, isInProgress };
};

export default function useTodaysVideoCalls() {
  const { selectedPharmacy } = useSelector((state) => state.pharmacySelector);
  const [currentTime, setCurrentTime] = useState(dayjs());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(dayjs());
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const today = dayjs().format('YYYY-MM-DD');

  const { data: videoCallsData } = useQuery({
    queryKey: ['upcoming-video-appointments', selectedPharmacy?._id, today],
    queryFn: () =>
      getTodayVideoCallAppointments({
        pharmacyId: selectedPharmacy?._id,
        startDate: today,
        endDate: today,
      }),
    enabled: Boolean(selectedPharmacy?._id),
    refetchInterval: 60000,
    meta: {
      errorMessage: 'Failed to fetch upcoming video call appointments',
    },
  });

  const videoCalls = (videoCallsData?.appointments ?? [])
    .map((videoCall) => toVideoCall(videoCall, currentTime))
    .filter((videoCall) => videoCall.isUpcoming || videoCall.isInProgress);

  return {
    videoCalls,
    currentTime,
  };
}

